<template>
  <div>
    <button
      v-if="ruleId == 0 && canUserEdit"
      v-b-modal="
        'bulkEditCopyMoveRule' +
          uniqueIdentifier +
          ruleId +
          (ruleGroup ? ruleGroup.id : '')
      "
      v-b-tooltip.hover
      class="btn btn-primary mr-1"
      placement="bottom"
      title="Ausgewählte Regeln verschieben oder kopieren"
      type="button"
      @click="
        expandPopup = true;
        allErrors = [];
      "
    >
      <i class="fas fa-coins" />
    </button>
    <b-modal
      :id="
        'bulkEditCopyMoveRule' +
          uniqueIdentifier +
          ruleId +
          (ruleGroup ? ruleGroup.id : '')
      "
      :ref="
        'bulkEditCopyMoveRule' +
          uniqueIdentifier +
          ruleId +
          (ruleGroup ? ruleGroup.id : '')
      "
      :title="
        'Regeln verschieben oder kopieren (' +
          selectedRules.length +
          ' ausgewählt)'
      "
      hide-footer
      no-fade
      size="xl"
      @hide="closeModal"
    >
      <div v-if="allErrors.length > 0">
        <h5>
          Beim Verschieben, Löschen oder Kopieren von Regeln gabe es Fehler
        </h5>
        <div
          v-for="(error, index) in allErrors"
          :key="index"
        >
          {{ error }}
        </div>
        <div
          v-if="!isLoading"
          class="mt-2"
        >
          <b-button
            class="ml-2"
            variant="primary"
            @click="
              hideModal(
                'bulkEditCopyMoveRule' +
                  uniqueIdentifier +
                  ruleId +
                  (ruleGroup ? ruleGroup.id : ''),
              )
            "
          >
            Ok
          </b-button>
        </div>
      </div>
      <u-loader v-if="isLoading" />
      <div v-else>
        <div
          class="w-100"
          style="height: 24px"
        >
          <button
            v-b-tooltip.hover
            :title="expandPopup ? 'minimieren' : 'maximieren'"
            class="float-right"
            placement="bottom"
            type="button"
            @click="expandPopup = !expandPopup"
          >
            <div v-if="expandPopup">
              <i class="fas fa-minus mr-1" />
              minimieren
            </div>

            <div v-else>
              <i class="fas fa-plus mr-1" />
              maximieren
            </div>
          </button>
        </div>
        <div v-if="expandPopup && allErrors.length == 0">
          <b-form-group class="ml-2">
            <b-form-radio
              v-model="copyMoveMode"
              :disabled="allGroups.length < 1"
              :value="copyMoveModes.moveToExising"
            >
              In bestehende Gruppe verschieben
            </b-form-radio>
            <b-form-radio
              v-model="copyMoveMode"
              :disabled="allGroups.length < 1"
              :value="copyMoveModes.copyToExisting"
            >
              In bestehende Gruppe kopieren
            </b-form-radio>
            <b-form-radio
              v-model="copyMoveMode"
              :value="copyMoveModes.moveToNew"
              class="mt-3"
            >
              In neue Gruppe verschieben
            </b-form-radio>
            <b-form-radio
              v-model="copyMoveMode"
              :value="copyMoveModes.copyToNew"
            >
              In neue Gruppe kopieren
            </b-form-radio>
            <b-form-radio
              v-model="copyMoveMode"
              :value="copyMoveModes.moveToUngrouped"
              class="mt-3"
            >
              In "ungruppierte Regeln" verschieben
            </b-form-radio>
            <b-form-radio
              v-model="copyMoveMode"
              :value="copyMoveModes.copyToUngrouped"
            >
              In "ungruppierte Regeln" kopieren
            </b-form-radio>
          </b-form-group>
          <b-row
            v-if="
              copyMoveMode == copyMoveModes.moveToExising ||
                copyMoveMode == copyMoveModes.copyToExisting
            "
          >
            <b-col class="col-2 pt-2">
              Gruppe
            </b-col>
            <b-col class="col-6">
              <b-select
                v-model="selectedGroup"
                :options="allGroups"
                class="mb-4"
                text-field="name"
                value-field="id"
              />
            </b-col>
          </b-row>

          <b-row
            v-if="
              copyMoveMode == copyMoveModes.moveToNew ||
                copyMoveMode == copyMoveModes.copyToNew
            "
            class="mb-4"
          >
            <b-col class="col-2 pt-2">
              Gruppen-Name
            </b-col>
            <b-col class="col-6">
              <b-input v-model="newGroupName" />
            </b-col>
          </b-row>
          <b-button
            v-b-tooltip.hover
            :disabled="
              ((copyMoveMode == copyMoveModes.moveToNew ||
                copyMoveMode == copyMoveModes.copyToNew) &&
                !newGroupName) ||
                ((copyMoveMode == copyMoveModes.moveToExising ||
                copyMoveMode == copyMoveModes.copyToExisting) &&
                !selectedGroup)
            "
            class="ml-2"
            placement="bottom"
            title="Speichern"
            variant="success"
            @click="executeOperation()"
          >
            {{
              copyMoveMode == copyMoveModes.moveToExising ||
                copyMoveMode == copyMoveModes.moveToUngrouped ||
                copyMoveMode == copyMoveModes.moveToNew
                ? "Verschieben"
                : "Kopieren"
            }}
          </b-button>

          <b-button
            class="ml-2"
            variant="danger"
            @click="
              hideModal(
                'bulkEditCopyMoveRule' +
                  uniqueIdentifier +
                  ruleId +
                  (ruleGroup ? ruleGroup.id : ''),
              );
              ruleToEdit = null;
            "
          >
            Abbrechen
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  AddGroupedRule,
  MoveCopyRules,
} from "@/services/minimum.wage.services/rules.minimum.wages.js";
import { GetValuesForGroupings } from "@/helpers/MinimumWageRulesHelper.js";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";

export default {
  mixins: [MinimumWageMixin],
  props: {
    selectedRules: {
      type: Array,
      required: true,
    },
    uniqueIdentifier: {
      type: String,
      required: true,
    },
    ruleGroup: {
      type: Object,
      default() {
        return null;
      },
    },
    editMode: {
      type: Boolean,
      default() {
        return true;
      },
    },
    configuration: {
      type: Object,
      required: true,
    },
    contractId: {
      type: String,
      default: "",
    },
    versionId: {
      type: Number,
      default: 0,
    },
    editionId: {
      type: Number,
      default: 0,
    },
    allGroups: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      expandPopup: true,
      selected: [],
      isLoading: false,
      groupConfiguration: null,
      groupProperties: [],
      hideSelection: true,
      ruleToEdit: null,
      ruleToEditObject: null,
      GetValuesForGroupings: GetValuesForGroupings,
      groupings: this.$store.state.mindestLohnKonfiguration.Groupings,
      selectedValues: [],
      objectToSave: {},
      newRule: false,
      groupedRuleConfig: null,
      ruleId: 0,
      propertiesToSet: [],
      copy: true,
      flagOptions: [
        { label: "", value: "" },
        { label: "Ja", value: "Y" },
        { label: "Nein", value: "N" },
      ],
      copyMoveMode: null,
      selectedGroup: null,
      newGroupName: "",
      copyMoveModes: {
        moveToExising: "moveToExising",
        moveToNew: "moveToNew",
        copyToExisting: "copyToExisting",
        copyToNew: "copyToNew",
        copyToUngrouped: "copyToUngrouped",
        moveToUngrouped: "moveToUngrouped",
      },
      allErrors: [],
    };
  },
  methods: {
    hideModal(modalId) {
      let modal = this.$refs[modalId];
      if (modal) {
        modal.hide();
      }
    },
    closeModal() {
      if (this.allErrors.length > 0) {
        this.$emit("ruleSaved");
      }
    },
    executeOperation() {
      this.isLoading = true;
      //History should be updated based on where the source rules are coming from
      switch (this.copyMoveMode) {
        case this.copyMoveModes.moveToExising:
          this.$store.state.history.shouldUpdateGroupHistory = true;
          if (this.ruleGroup == null) {
            this.$store.state.history.shouldUpdateListitemHistory = true;
          }
          this.processAllRules(false, this.selectedGroup);
          break;
        case this.copyMoveModes.moveToNew:
          this.$store.state.history.shouldUpdateGroupHistory = true;
          if (this.ruleGroup == null) {
            this.$store.state.history.shouldUpdateListitemHistory = true;
          }
          this.createNewGroup(
            (success) => {
              this.processAllRules(false, success.id);
            },
            () => {
              this.allErrors.push(
                `Die neue Gruppe (${this.newGroupName ? this.newGroupName : "neue Gruppe"}) konnte nicht erstellt werden. Bitte Logs prüfen.`,
              );
              this.isLoading = false;
            },
          );
          break;
        case this.copyMoveModes.copyToExisting:
          this.$store.state.history.shouldUpdateGroupHistory = true;
          this.processAllRules(true, this.selectedGroup);
          break;
        case this.copyMoveModes.copyToNew:
          this.$store.state.history.shouldUpdateGroupHistory = true;
          this.createNewGroup(
            (success) => {
              this.processAllRules(true, success.id);
            },
            (error) => {
              console.log(error);
              this.isLoading = false;
            },
          );
          break;
        case this.copyMoveModes.moveToUngrouped:
          if (this.ruleGroup != null) {
            this.$store.state.history.shouldUpdateListitemHistory = true;
            this.$store.state.history.shouldUpdateGroupHistory = true;
          }
          this.processAllRules(false, null);
          break;
        case this.copyMoveModes.copyToUngrouped:
          this.$store.state.history.shouldUpdateListitemHistory = true;
          if (this.ruleGroup != null) {
            this.$store.state.history.shouldUpdateGroupHistory = true;
          }
          this.processAllRules(true, null);
          break;

        default:
          this.isLoading = false;
          break;
      }
    },
    createNewGroup(onSuccess, onError) {
      var newGroupedRule = {
        id: 0,
        ruleConfigurationId: this.configuration.id,
        name: this.newGroupName ? this.newGroupName : "neue Gruppe",
        order: 0,
        groupEntries: [],
      };

      AddGroupedRule(
        this.contractId,
        this.versionId,
        this.editionId,
        this.configuration.id,
        newGroupedRule,
        (reponse) => {
          onSuccess(reponse);
        },
        (error) => {
          onError(error);
        },
      );
    },
    moveCopyRules(reqObj) {
      return new Promise((resolve) => {
        MoveCopyRules(
          this.contractId,
          this.versionId,
          this.editionId,
          this.configuration.id,
          reqObj,
          () => {
            resolve();
          },
          () => {
            this.allErrors.push(
              `Die Regeln konnten nicht ${reqObj.copy ? "kopiert" : "verschoben"} werden. Bitte Logs prüfen.`,
            );
            resolve();
          },
        );
      });
    },
    processAllRules(copy, newRuleGroup) {
      this.errorObject = null;
      this.isLoading = true;
      this.allErrors = [];

      let reqObj = {
        targetRuleGroupId: newRuleGroup,
        ruleIds: this.selectedRules.map((rule) => rule.id),
        copy: copy,
      };

      this.moveCopyRules(reqObj)
        .then(() => {
          this.isLoading = false;

          if (this.allErrors.length == 0) {
            this.hideModal(
              "bulkEditCopyMoveRule" +
                this.uniqueIdentifier +
                this.ruleId +
                (this.ruleGroup ? this.ruleGroup.id : ""),
            );
            this.$emit("ruleSaved");
          }
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
  },
};
</script>

<style>
.menuable__content__active {
  z-index: 6000 !important;
}
</style>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.col-05 {
  -ms-flex: 0 0 2%;
  -webkit-box-flex: 0;
  flex: 0 0 2%;
  max-width: 2%;
}
</style>
